module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="facet '+
((__t=( size ))==null?'':__t)+
'">\r\n\t<div class="facetheader">\r\n\t\t<h4 class="title">'+
((__t=( name ))==null?'':__t)+
'</h4>\r\n\t\t<a class="reset" href="#">&times;</a>\r\n\t\t';
 if (typeof searchable != 'undefined') { 
__p+='\r\n\t\t\t<input type="text" class="tagSearch" placeholder="search">\r\n\t\t\t<a class="clearTagSearch" href="#">&times;</a>\r\n\t\t';
 } 
__p+='\r\n\t</div>\r\n\t<div class="chart"></div>\r\n</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/views/sidebar/archive/facets/facetView.tmpl
 ** module id = 16
 ** module chunks = 0
 **/